import { useMutation } from 'react-query'

import { APIError } from '../../../../../utils'
import { RegisterVatDeclarationPayload, registerVatDeclarationPayment } from '../../../query-api'

interface UseRegisterVatDeclarationPaymentProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useRegisterVatDeclarationPayment = (props?: UseRegisterVatDeclarationPaymentProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate: registerPayment, isLoading: isProcessing } = useMutation(
    (registerVatDeclarationPaymentPayload: RegisterVatDeclarationPayload) =>
      registerVatDeclarationPayment(registerVatDeclarationPaymentPayload),
    {
      onError,
      onSuccess,
    },
  )

  return { isProcessing, registerPayment }
}
